<template>
    <div class="text-caption q-py-xs">
        <q-icon v-if="withIcon" name="help_outline" size="18px" class="q-mr-xs" />
        <slot />
    </div>
</template>

<script setup>
defineProps({
    withIcon: Boolean,
})
</script>
